import React, { useEffect, useState } from 'react';
import { formatToZMW, rootUrl } from '../../../helpers';
import axios from 'axios';


const CustomerData = ({ id }) => {
    const [data, setData] = useState([]); // To store the merged data (bills + receipts)
    const [balance, setBalance] = useState(0.0); // To track the balance
    const [loading, setLoading] = useState(false); // To manage loading state
    const [error, setError] = useState(null); // To handle errors

    useEffect(()=>{
        fetchData()
    }, [])

    const fetchData = () => {
        setLoading(true); 
        setError(null); 

    
        axios.get(rootUrl(`/customerStatement/${id}`))
            .then(response => {
                const { bills, receipts } = response.data; 
                const mergedData = [...bills, ...receipts];

                // Sort the merged data by date (assuming 'date' is in a valid format for Date parsing)
                const sortedData = mergedData.sort((a, b) => new Date(a.date) - new Date(b.date));
    
                setData(sortedData); // Set sorted data
                setBalance(0.0); // Reset balance
    
                setData(mergedData); 
                setBalance(0.0); 
    
                // Calculate the balance
                mergedData.forEach(res => {
                    if (res.invoice_no != null) {
                        setBalance(prevBalance => prevBalance + parseFloat(res.amount));
                    } else {
                        setBalance(prevBalance => prevBalance - parseFloat(res.amount));
                    }
                });
            })
            .catch(error => {
                setError('Error fetching data');
                console.error(error);
            })
            .finally(() => setLoading(false)); // Stop loading
    };
    return (
        <div>
          
            {loading && <p>Loading...</p>} {/* Loading indicator */}
            {error && <p className="text-red-500">{error}</p>} {/* Error message */}
            
            {data.length === 0 ? (
                <p>No data available.</p>
            ) : (
                <>
                    <i onClick={() => window.history.back()} className="fa fa-arrow-circle-left fa-2x mb-3"></i>
                    <br />
                    <div className="mb-4">
                        <p className="text-lg font-semibold text-gray-600"></p>
                    </div>
                    <table className="min-w-full border border-gray-300">
    <thead>
        <tr className="text-left bg-blue-900 text-white">
            <th className="border-b px-4 py-2">Date</th>
            <th className="border-b px-4 py-2">Invoice #</th>
            <th className="border-b px-4 py-2">Description</th>
            <th className="border-b px-4 py-2">Debit</th>
            <th className="border-b px-4 py-2">Credit</th>
            <th className="border-b px-4 py-2">Balance</th>
        </tr>
    </thead>
    <tbody>
        {(() => {
            let runningBalance = 0; // Initialize the running balance
            return data.map((res, index) => {
                // Calculate debit and credit
                const debit = res.invoice_no != null ? res.amount : 0;
                const credit = res.invoice_no == null ? res.amount : 0;

                // Update running balance
                runningBalance += debit - credit;

                return (
                    <tr key={index}>
                        <td className="border-b px-4 py-2">{res.date.substring(0, 10)}</td>
                        <td className="border-b px-4 py-2">
                            {res.invoice_no != null ? res?.invoice_no : res?.receipt_no}
                        </td>
                        <td className="border-b px-4 py-2">{res.description}</td>
                        <td className="border-b px-4 py-2">{formatToZMW(debit)}</td>
                        <td className="border-b px-4 py-2">{formatToZMW(credit)}</td>
                        <td className="border-b px-4 py-2">{formatToZMW(runningBalance)}</td>
                    </tr>
                );
            });
        })()}
    </tbody>
</table>

                </>
            )}
        </div>
    );
};

export default CustomerData;
